"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalMessage = void 0;
class ExternalMessage {
    constructor(opts) {
        this.to = opts.to;
        this.body = opts.body;
        if (opts.from !== undefined && opts.from !== null) {
            this.from = opts.from;
        }
        else {
            this.from = null;
        }
        if (opts.importFee !== undefined && opts.importFee !== null) {
            this.importFee = opts.importFee;
        }
        else {
            this.importFee = 0;
        }
    }
    writeTo(cell) {
        cell.bits.writeUint(2, 2);
        cell.bits.writeAddress(this.from);
        cell.bits.writeAddress(this.to);
        cell.bits.writeCoins(this.importFee);
        this.body.writeTo(cell);
    }
}
exports.ExternalMessage = ExternalMessage;
